export default __webpack_public_path__ + "static/Artist-06ba8516174cedcf4d646040635b0245.png";